@if (!loading && !error) {
<a class="widget" [ngStyle]="{ backgroundImage: 'url(' + event?.banner_url + ')' }">
  <div class="widget-header">
    @if (event && event.logo_url) {
    <img class="event-logo" [src]="event.logo_url" />
    }
    <h1>{{ event?.title }}</h1>
    <p class="date">
      <span translate>common.date.from </span>
      <span class="bold">{{ event!.start_date * 1000 | date : "dd MMM" : timezone : lang }}</span>
      <span translate> common.date.to </span>
      <span class="bold">{{ event!.end_date * 1000 | date :'mediumDate' : timezone: lang}}</span>
    </p>
  </div>

  @if(event?.sport === 'cycling' || event?.sport === 'running' || event?.sport
  === 'rowing'){
  <img class="sport-icon" [src]="'assets/svg/' + event!.sport + '.svg'" alt="" />
  }

  <div class="score">
    <p class="total">
      <span class="total" appIncrement>{{
        event!.total < 1000 ? event!.total : event!.total / 1000 }}</span>
          {{ event!.total < 1000 ? "m" : "km" }} </p>
            <p class="goal" translate>
              @switch (event?.sport){
              @case('running') { event-widget.runing}
              @case('cycling') {event-widget.cycling}
              @case('rowing') {event-widget.rowing}
              @default {event-widget.covered}}.
            </p>
  </div>
  <img class="kinomap-icon" src="assets/svg/kinomap.svg" alt="kinomap application icon." />
  <div class="gradient"></div>
</a>
} @else if(!error && loading) {
<div class="widget loading">
  <img class="kinomap-icon-loading" src="assets/svg/kinomap.svg" alt="kinomap application icon." />
</div>
} @else {
<div class="widget error">

  <div class="error-status">
    {{error}}
  </div>
  <h3 translate>error.event.title</h3>
  @switch (error) {
  @case(403) {
  <span translate>error.event.403</span>
  }

  @case(404) {
  <span translate>error.event.404</span>
  }

  @default {
  <span translate>error.event.default</span>
  }
  }

  <img class="kinomap-icon" src="assets/svg/kinomap.svg" alt="kinomap application icon." />
</div>
}